export default __webpack_public_path__ + "static/media/Graphics_Mike-01-min.6fc7f5ae.jpg";